/**
 * ST-PERF hover-media: defers the product card's secondary (hover) image until
 * the user actually hovers the card on desktop. The image markup lives in a
 * sibling <template> (browsers never fetch images inside <template>), so nothing
 * is requested until we clone it on the first pointerenter.
 * Rollback: delete this asset + its <script> tag in theme.liquid + revert the
 * <template>/<hover-media> wrap in snippets/product-card.liquid.
 */
(function () {
  if (customElements.get('hover-media')) return;
  var finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  class HoverMedia extends HTMLElement {
    connectedCallback() {
      // Touch devices hide the hover image entirely (hidden md:block) and never
      // hover, so skip hydration there.
      if (!finePointer) return;
      var tpl = this.previousElementSibling;
      if (!tpl || tpl.tagName !== 'TEMPLATE') return;
      var trigger = this.closest('.product-card') || this.closest('a') || this.parentElement;
      if (!trigger) return;
      var self = this;
      var hydrate = function () {
        // Clone the image as a direct child of the .product-card__secondary
        // wrapper (before this marker), NOT inside <hover-media>, so the theme's
        // direct-child CSS (.media>img object-fit/position, hover scale) applies.
        // importNode, not cloneNode: WebKit 26 won't composite a <video> adopted from a <template>.
        var wrapper = self.parentElement;
        wrapper.insertBefore(document.importNode(tpl.content, true), self);
      };
      trigger.addEventListener('pointerenter', hydrate, { once: true });
    }
  }

  customElements.define('hover-media', HoverMedia);
})();
